import React, { useEffect } from 'react';
import SettingsView from './SettingsView';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4" onClick={onClose}>
      <div className="bg-[var(--color-bg-secondary)] text-[var(--color-text-primary)] rounded-lg shadow-xl w-full max-w-lg p-8 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] text-3xl">&times;</button>
        <h2 className="text-2xl font-bold text-[var(--color-accent)] mb-6">표시 설정</h2>
        <SettingsView />
      </div>
    </div>
  );
};

export default SettingsModal;